const bodiesFilters = [
    {
        filterDisplayName: "Occasions",
        subFilters: [
            {
                filterDisplayName: "Birthdays",
                filterType: "collection",
                filterHandle: "birthday-tops",
            },
            {
                filterDisplayName: "Weddings",
                filterType: "collection",
                filterHandle: "wedding-torsos",
            },
            {
                filterDisplayName: "Valentines",
                filterType: "collection",
                filterHandle: "valentines-romantic",
            },
            {
                filterDisplayName: "Christmas",
                filterType: "collection",
                filterHandle: "christmas-torsos",
            },
            {
                filterDisplayName: "Other",
                filterType: "collection",
                filterHandle: "other-occasions-torsos",
            },
        ],
    },
    {
        filterDisplayName: "Casual",
        subFilters: [
            // {
            //     filterDisplayName: "All casual torsos",
            //     filterType: "collection",
            //     filterHandle: "casual-wear-torsos",
            // },
            {
                filterDisplayName: "Childrens",
                filterType: "collection",
                filterHandle: "childrens-tops",
            },
            {
                filterDisplayName: "Maternity",
                filterType: "collection",
                filterHandle: "maternity-torsos",
            },
            {
                filterDisplayName: "Hoodies & Jumpers",
                filterType: "collection",
                filterHandle: "hoodies-and-jumpers",
            },
            {
                filterDisplayName: "Casual Jackets",
                filterType: "collection",
                filterHandle: "casual-jackets",
            },
            {
                filterDisplayName: "Other Casual",
                filterType: "collection",
                filterHandle: "other-casual-torsos",
            },
        ],
    },
    {
        filterDisplayName: "Sports",
        subFilters: [
            {
                filterDisplayName: "Football",
                filterType: "collection",
                filterHandle: "football-collection",
            },
            {
                filterDisplayName: "Other Sports",
                filterType: "collection",
                filterHandle: "other-sports",
            },
        ],
    },
    {
        filterDisplayName: "Work",
        subFilters: [
            {
                filterDisplayName: "Officewear",
                filterType: "collection",
                filterHandle: "officewear-torsos",
            },
            {
                filterDisplayName: "Other Jobs",
                filterType: "collection",
                filterHandle: "health-profession-torsos",
            },
        ],
    },
    {
        filterDisplayName: "Retro",
        filterType: "collection",
        filterHandle: "retro-torsos",
        subFilters: false,
    },
]

export { bodiesFilters }
